var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-news"},[_c('a',{attrs:{"href":"https://www.facebook.com/pocketcurator/","target":"_blank"}},[_c('i',{staticClass:"icon-facebook"}),_vm._v("\n    "+_vm._s(_vm.textData[_vm.lang.key].btnNews.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd1f678","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/BtnNews.vue
// module id = null
// module chunks = 